var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00B0F0",
    d: "M6.345 2.55C10.601.015 16.028.637 19.6 4.07c-.37.32-.69.63-1 .93-1.774-1.707-4.138-2.663-6.6-2.67-5.34 0-9.67 4.33-9.67 9.67s4.33 9.67 9.67 9.67c2.462-.007 4.826-.963 6.6-2.67.31.31.63.62.98.94-2.034 1.965-4.752 3.062-7.58 3.06-4.955.01-9.305-3.293-10.625-8.068-1.321-4.776.714-9.845 4.97-12.381zM18.22 6.86c1.184 1.103 2.126 1.995 2.85 2.713l.319.32C22.502 11.017 23 11.66 23 12c0 .57-1.41 2-4.78 5.22l-.95-.95c1.32-1.28 2.34-2.26 3.09-3l.54-.55H7V11.4h13.93c-.16-.18-.36-.37-.57-.59-.75-.78-1.77-1.76-3.09-3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.b398863169f1de61e85e8bb97f6d944d.svg";
export { ForwardRef as ReactComponent };